import { TratamientoListItem } from "./TratamientoItem";
import { useState, useEffect } from "react";
import * as API from "../services/tratamientos";

export function TratamientoList(props) {
  const [tratamientos, setTratamiento] = useState([]);
  const tratamientoStringList = props?.list?.toString();

  useEffect(() => {
    if (props.userRole.includes('administrador') || props.userRole.includes('psicologia-hospital') || props.userRole.includes('medicina') || props.userRole.includes('paciente')) {
      API.getTratamientoByIds(tratamientoStringList).then(setTratamiento).catch(console.log);
    } else {
      API.getTratamientoByIdsByEspecialista(tratamientoStringList, props.especialistaId).then(setTratamiento).catch(console.log);
    }
  }, [tratamientoStringList]);
  return (
    <>
      {tratamientos?.length ? (
        tratamientos === "Sin Tratamientos" ? (
          <div>Sin tratamientos</div>
          ) : (
          <ul className="tratamiento-list">
            {tratamientos?.map((tratamiento) => (
              <TratamientoListItem key={tratamiento.id} {...props} {...tratamiento} />
            ))}
          </ul>
          )
      ) : (
        <div>Loading...</div>
      )}
    </>
  );
}